import { useCallback, useEffect, useRef, useState } from 'react';

import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';
import { UseDisclosureOptions } from './types';

function useDisclosure(options: UseDisclosureOptions = {}) {
  const {
    defaultIsOpen = false,
    isOpen: isOpenProp,
    onClose: onCloseProp,
    onOpen: onOpenProp,
  } = options;

  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const prevIsOpenProp = useRef(isOpenProp);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (isOpenProp && prevIsOpenProp.current !== isOpenProp) {
      setIsOpen(isOpenProp);
      prevIsOpenProp.current = isOpenProp;
    }
  }, [isOpen, isOpenProp]);

  return {
    isOpen,
    onClose: callAllFn(onClose, onCloseProp),
    onOpen: callAllFn(onOpen, onOpenProp),
  };
}

export default useDisclosure;
